import {Component, Input} from '@angular/core';
import {CompanyResponse, EventResponse} from '../../../../@shared/models/response.module';
import {EventsService} from '../../../../@shared/services/events-service';
import {AQH_EVE_0} from '../../../../@shared/models/input.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddEvent} from './components/add-event/add-event';
import {Router} from '@angular/router';

@Component({
  selector: 'app-company-profile-events',
  standalone: false,
  templateUrl: './company-profile-events.html',
  styleUrl: './company-profile-events.css'
})
export class CompanyProfileEvents {
  @Input() company: CompanyResponse
  events: EventResponse[]
  loading: boolean = false;


  constructor(private eventService: EventsService,
              private modalService: NgbModal,
              private router: Router) {
  }


  ngOnInit() {
    this.getCompanyEvents()
  }

  getCompanyEvents() {
    let payload: AQH_EVE_0 = {
      company_id: this.company.company_id
    }
    this.eventService.getEvents(payload).subscribe((res) => {
      this.events = res.data
    })
  }

  openAddEvent() {
    this.router.navigate(['company-profile/add-event'])
  }


}
